export interface OrganizationParameter {
  id: number;
  organizationId: number;
  type:
    | 'FlightProvider'
    | 'PaymentGateway'
    | 'Currency'
    | 'LowestLogicalFare'
    | 'IsPurchaseAllowedBelowBookWindowOrLowCost'
    | 'BookWindow'
    | 'DoubleTicketFeeIsOwc'
    | 'PolicyReasonCode'
    | 'JustificationReasonCode'
    | 'TravelDeclineReasonCode'
    | 'Restriction';
  context: 'epower'
    | 'currency'
    | 'International'
    | 'Domestic'
    | 'HotelSearch'
    | 'SecondBillingAddress'
    | 'IntegrationReportPurchaseRow'
    | 'SearchPriority';
  key: 'username'
    | 'currency'
    | 'timeWindow'
    | 'maxStops'
    | 'Currency'
    | 'Country'
    | 'Day'
    | 'ShowSecondBillingAddress'
    | 'ShowIntegrationReportPurchaseRow'
    | 'ActivateSearchPriority'
    | 'passowrd'
    | 'url'
    | 'password'
    | 'kvkk_url'
    | 'express_consent_url'
    | 'etk_url'
    | 'provider';

  value: string;
  encrypted: boolean;
  createdBy: string;
  updatedBy: string;
  created_at: string;
  updated_at: string;
  deleted_at: string;
}

export class ProviderItem {
  id:any;
  type: string;
  provider: string;
  username: OrganizationParameter;
  password: OrganizationParameter;
  serviceURL: OrganizationParameter;
  serviceKey: OrganizationParameter;
}

export class CreditCardProvider {
  provider: string;
  username: OrganizationParameter;
  password: OrganizationParameter;
  clientid: OrganizationParameter;
  storekey?: OrganizationParameter
  storetype?: OrganizationParameter;
  url_service?: OrganizationParameter;
  url_3d?: OrganizationParameter;
}

export class Restrictions {
  hotelSearch: HotelSearchRestrictions;
  secondBillingAddress: OrganizationParameter;
  integrationReportPurchaseRow: OrganizationParameter;
  searchPriority: OrganizationParameter;
  mailOrder: OrganizationParameter;
  tourvisioRentingAgency: TourvisioRentingAgencyRestrictions;
}

export class HotelSearchRestrictions {
  currency: OrganizationParameter;
  country: OrganizationParameter;
  day: OrganizationParameter;
}

export class TourvisioRentingAgencyRestrictions {
  restrictedOfferTypes: OrganizationParameter;
}

export class KVKKProvider{
  provider: OrganizationParameter;
  username: OrganizationParameter;
  password: OrganizationParameter;
  client_id: OrganizationParameter;
  client_secret: OrganizationParameter;
  url: OrganizationParameter;
  kvkk_url?: OrganizationParameter;
  express_consent_url?: OrganizationParameter;
  etk_url?: OrganizationParameter;
  integration_active?: OrganizationParameter;
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/utils/objects/organization-parameter.ts